const trustLogos = [
  { src: "/logos/constant-contact.svg", alt: "Constant Contact", width: 110 },
  { src: "/logos/shopify.svg", alt: "Shopify", width: 75 },
  { src: "/logos/mckinsey.svg", alt: "McKinsey", width: 100 },
  { src: "/logos/instacart.svg", alt: "Instacart", width: 80 },
  { src: "/logos/huggingface.svg", alt: "Hugging Face", width: 80 },
];

interface TrustBarProps {
  className?: string;
}

const TrustBar = ({ className = "" }: TrustBarProps) => {
  return (
    <div className={`flex items-center gap-6 mt-4 opacity-40 ${className}`}>
      {trustLogos.map((logo) => (
        <img
          key={logo.alt}
          src={logo.src}
          alt={logo.alt}
          width={logo.width}
          height={20}
          className="h-5 w-auto object-contain [filter:grayscale(100%)]"
          loading="lazy"
          decoding="async"
        />
      ))}
    </div>
  );
};

export default TrustBar;
